import { useMemo } from "react";
import {
  BooleanField,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  NumberField,
  ShowButton,
  TextField,
} from "react-admin";
import { CouponTypeEnum } from "../../enums/CouponTypeEnum";
import { ProductType } from "../../enums/ProductType";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import { formatSlotSize } from "../../utils/FormatSlotSize";
import { useSlotSizeOptions } from "../../utils/SlotSizeOptions";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const baseFilterFields: CommonFilterField[] = [
  {
    type: "select",
    label: "Coupon Type",
    source: "couponType",
    options: Object.values(CouponTypeEnum).map((value) => ({
      value,
      label: value,
    })),
  },
  {
    type: "select",
    label: "Product Type",
    source: "productType",
    options: Object.values(ProductType).map((value) => ({
      value,
      label: value,
    })),
  },
  { type: "text", label: "Name", source: "name" },
  { type: "text", label: "Min Price", source: "minPrice", numeric: true },
  { type: "text", label: "Max Price", source: "maxPrice", numeric: true },
];

const CouponSkuList = (props: any) => {
  const slotSizeOptions = useSlotSizeOptions();
  const filterFields = useMemo<CommonFilterField[]>(
    () => [
      {
        type: "select",
        label: "Slot Size",
        source: "slotSize",
        options: slotSizeOptions.map((value) => ({ value, label: formatSlotSize(value) })),
        // Filter values restored from the URL come back as strings
        fromFilter: (value: any) => Number(value),
      },
      ...baseFilterFields,
    ],
    [slotSizeOptions]
  );

  return (
    <List
      {...props}
      sort={{field:'id', order:'desc'}}
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Coupon Sku">
      <Datagrid bulkActionButtons={false} sx={commonDatagridSx} rowClick="show">
        <NumberField source="id" />
        <TextField source="name" sortable={false} />
        <TextField source="value" sortable={false} />
        <TextField source="price" sortable={false} />
        <TextField source="productType" sortable={false} />
        <TextField source="couponType" sortable={false} />
        <TextField source="noOfPeople" sortable={false} />
        <FunctionField label="Slot Size" render={(record: any) => formatSlotSize(record?.slotSize)} />
        <TextField source="numberOfDays" sortable={false} />
        <TextField source="minimumOrderValue" sortable={false} />
        <BooleanField source="isActive" />
        <TextField source="maximumDiscountAmount" sortable={false} />
        <TextField source="maximumUsageLimit" sortable={false} />
        <ShowButton />
        <EditButton />
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};

export default CouponSkuList;
